import { z } from 'zod';

export const timeFormatHoursMinutesSecondsSchema = z
  .string()
  .regex(/^\d{2}:\d{2}:\d{2}$/, 'Time must be in HH:MM:SS format');

export const timeFormatHoursMinutesSchema = z
  .string()
  .regex(/^\d{2}:\d{2}$/, 'Invalid duration format. Expected format: "HH:MM"');
